import React from 'react';
export function Newsletter() {
  return <section className="py-24 px-6 border-b border-grey-divider bg-white" data-id="element-216">
      <div className="max-w-3xl mx-auto text-center" data-id="element-217">
        <h2 className="text-2xl md:text-3xl font-display font-bold mb-6 tracking-[0.25em] uppercase" data-id="element-218">
          JOIN THE Djili's Culture
        </h2>
        <p className="text-xs font-light text-black/80 mb-4 tracking-widest leading-relaxed uppercase" data-id="element-219">
          Be the FIRST to learn about our new arrivals, in-store events and our
          'behind-the-scenes' projects.
        </p>
        <p className="text-[10px] font-display font-bold text-black mb-10 tracking-[0.2em] uppercase" data-id="element-220">
          Sign-up now for our emails and get 10% OFF in-store.
        </p>

        <form className="flex flex-col md:flex-row gap-0 max-w-xl mx-auto group" data-id="element-221">
          <div className="relative flex-grow" data-id="element-222">
            <input type="email" placeholder="EMAIL ADDRESS" className="w-full bg-transparent border-b border-black/20 py-4 text-[10px] font-display tracking-[0.3em] focus:outline-none focus:border-black transition-colors placeholder:text-black/20" data-id="element-223" />
            <div className="absolute bottom-0 left-0 w-0 h-[1px] bg-black transition-all duration-500 group-focus-within:w-full" data-id="element-224" />
          </div>
          <button className="bg-black text-white px-12 py-4 text-[10px] font-display uppercase tracking-[0.3em] hover:bg-black/90 transition-all duration-300 mt-4 md:mt-0 md:ml-8" data-id="element-225">
            Subscribe
          </button>
        </form>
      </div>
    </section>;
}